// jshint esversion: 6
export default {
  token: state => state.token,
  isLoggedIn: state => !!state.token
};
